import { render, staticRenderFns } from "./Cn-DataTable.vue?vue&type=template&id=13a4f3ef&scoped=true&"
import script from "./Cn-DataTable.vue?vue&type=script&lang=ts&"
export * from "./Cn-DataTable.vue?vue&type=script&lang=ts&"
import style0 from "./Cn-DataTable.vue?vue&type=style&index=0&id=13a4f3ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4f3ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
